import { createSlice } from '@reduxjs/toolkit';

export type Poem = {
  id: number;
  title: string;
  language: string;
  author?: string;
  content: string;
  tags?: string[]; // In store we normalize to []
  category?: string;
  status?: 'DRAFT' | 'REVIEW' | 'PUBLISHED' | 'REJECTED';
  published?: boolean;
  createdAt?: string;
  updatedAt?: string;
  description?: string;
  mood?: string;
  theme?: string;
  country?: string; // ISO country code (e.g., 'DE', 'IN', 'XX' for stateless)
  createdBy?: string;
  createdByUsername?: string;
  likeCount?: number;
  bookmarkCount?: number;
  shareCount?: number;
  copyCount?: number;
  viewCount?: number;
  likedByCurrentUser?: boolean;
  bookmarkedByCurrentUser?: boolean;
};

// We keep a minimal state just in case we need to store non-API transient state.
// Currently, RTK Query handles all API state.
type State = {
  // Add any client-side only state here if needed in the future
};

const initialState: State = {};

const poemsSlice = createSlice({
  name: 'poems',
  initialState,
  reducers: {},
});

export default poemsSlice.reducer;
